"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Switch = _interopRequireDefault(require("../../../components/Switch"));
var _Bubble = _interopRequireDefault(require("../../../components/Bubble"));
var _BubbleSelectBlock = _interopRequireDefault(require("../../../components/BubbleSelectBlock"));
var _NumberInput = _interopRequireDefault(require("../../../components/TextFields/NumberInput"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _TextInput = _interopRequireDefault(require("../../../components/TextFields/TextInput"));
var _BlockContent = _interopRequireDefault(require("../../../components/BlockContent"));
var _HeaderDiv = _interopRequireDefault(require("../../../components/HeaderDiv"));
var _theme = require("../../../theme");
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
var _services = require("../../../services");
var localizationMaps = _interopRequireWildcard(require("../../../localization/maps"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SpendingAccounts = /*#__PURE__*/function (_Component) {
  function SpendingAccounts() {
    var _this;
    (0, _classCallCheck2["default"])(this, SpendingAccounts);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, SpendingAccounts, [].concat(args)), _this.state = {
      data: null
    }, _this._setData = function (data) {
      var defaults = {
        isSelected: data.isSelected || false,
        isPooled: data.isPooled || false,
        // allow the user to set their own amounts using the pooled amount
        includeHsa: data.includeHsa || false,
        hsaAmount: data.hsaAmount || 0,
        allowHsaRollover: data.allowHsaRollover || 'Yes',
        setMaxHsaRollover: data.setMaxHsaRollover || 'No',
        maxHsaRollover: data.maxHsaRollover || 0,
        includeLsa: data.includeLsa || false,
        lsaAmount: data.lsaAmount || 0,
        allowLsaRollover: data.allowLsaRollover || 'Yes',
        setMaxLsaRollover: data.setMaxLsaRollover || 'No',
        maxLsaRollover: data.maxLsaRollover || 0,
        pooledAmountAvailable: data.pooledAmountAvailable || 0,
        allowPooledAmountRollover: data.allowPooledAmountRollover || 'Yes',
        setMaxPooledRollover: data.setMaxPooledRollover || 'No',
        terminationAge: typeof data.terminationAge === "number" ? data.terminationAge : 75,
        eligibilityPeriod: typeof data.eligibilityPeriod === "number" ? data.eligibilityPeriod : 3,
        minHoursPerWeek: typeof data.minHoursPerWeek === "number" ? data.minHoursPerWeek : 24,
        isQuarterlyAllowance: data.isQuarterlyAllowance || false,
        isProrated: data.isProrated || false,
        proratedBy: data.proratedBy || 'day',
        // day, month or quarter
        notes: data.notes || null
      };
      _this.setState({
        data: _objectSpread({}, defaults)
      });
      return defaults;
    }, _this._handleChange = function (field, value) {
      // we are viewing a revision so we don't need to set data in state
      if (_this.props.revision) {
        return;
      }
      _this.setState({
        data: _objectSpread(_objectSpread({}, _this.state.data), {}, (0, _defineProperty2["default"])({}, field, value))
      });
    }, _this._saveInGlobalState = function (field, value) {
      // we are viewing a revision so we don't need to set data in state
      if (_this.props.revision) {
        return;
      }
      if (field === 'isProrated' && value === true) {
        _this._saveInGlobalState('isQuarterlyAllowance', false);
      }
      if (field === 'notes' && value.toString().length === 0) {
        value = null;
      }
      if (_this.props.type === "modular") {
        _this.props.saveModularField(_this.props.classID, _this.props.tier, 'health', 'spendingAccounts', field, value);
      } else {
        _this.props.savePlanDesignField(_this.props.selectedClassID, _this.props.selectedDesignID, 'spendingAccounts', field, value);
      }
      _this.props.setChangesMadeFlag();
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(SpendingAccounts, _Component);
  return (0, _createClass2["default"])(SpendingAccounts, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // we are viewing a revision so we don't need to set data in state
      if (this.props.revision) {
        return;
      }
      var defaults = this._setData(this.props.data);
      if (this.props.type === "modular") {
        // save the init data in global state so it's there for the save
        this.props.saveModularBenefitInitData(this.props.classID, this.props.tier, 'health', 'spendingAccounts', defaults);
        return;
      }

      // save the init data in global state so it's there for the save
      this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, this.props.selectedDesignID, 'spendingAccounts', defaults);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        data = _this$props.data,
        revision = _this$props.revision,
        type = _this$props.type,
        selectedDesignID = _this$props.selectedDesignID,
        savePlanDesignBenefitInitData = _this$props.savePlanDesignBenefitInitData,
        selectedClassID = _this$props.selectedClassID;

      // Check if specific props have changed to avoid unnecessary updates
      if (data !== prevProps.data || revision !== prevProps.revision || type !== prevProps.type || selectedDesignID !== prevProps.selectedDesignID) {
        var defaults = this._setData(data);

        // we are viewing a revision so we don't need to set data in state
        if (revision || type === "modular") {
          return;
        }
        if (selectedDesignID !== prevProps.selectedDesignID) {
          // save the init data in global state so it's there for the save
          savePlanDesignBenefitInitData(selectedClassID, selectedDesignID, 'spendingAccounts', defaults);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!this.state.data) {
        return null;
      }
      var _this$props2 = this.props,
        errors = _this$props2.errors,
        whitelabel = _this$props2.whitelabel,
        revision = _this$props2.revision,
        isRevisionBlock = _this$props2.isRevisionBlock,
        lightTierColor = _this$props2.lightTierColor,
        darkTierColor = _this$props2.darkTierColor;
      var data = this.state.data;
      var isSelected = Boolean(data.isSelected);
      var tierLabelStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 90,
        padding: 5,
        marginRight: 10,
        backgroundColor: lightTierColor
      };
      return /*#__PURE__*/_react["default"].createElement(_BlockContent["default"], {
        style: isRevisionBlock ? {
          backgroundColor: '#F7F9FA'
        } : null
      }, /*#__PURE__*/_react["default"].createElement(_HeaderDiv["default"], {
        style: {
          borderBottom: isSelected ? "1.5px solid #F1F1F1" : null
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        bold: true,
        display: "block",
        margin: "20px 0",
        color: whitelabel.primaryColor || _theme.colors.skyBlue
      }, revision ? isRevisionBlock ? "".concat(_i18n["default"].t(_tokens["default"].titles.SpendingAccounts), " (").concat(revision.revisionID, ")") : _i18n["default"].t(_tokens["default"].labels.planDesign.spendingAccountsCurrent) : _i18n["default"].t(_tokens["default"].titles.spendingAccounts)), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-end',
          flexDirection: 'row',
          flex: 1
        }
      }, this.props.tier && /*#__PURE__*/_react["default"].createElement("div", {
        style: tierLabelStyle
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        bold: true,
        medium: true,
        color: darkTierColor
      }, this.props.tier.toUpperCase())), /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
        checked: data.isSelected,
        onChange: function onChange() {
          return _this2._saveInGlobalState("isSelected", !isSelected);
        }
      }))), isSelected && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          paddingTop: 20,
          paddingBottom: 50
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.combineHealthLifestyleSpendingMaximums)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].buttons.yes),
          selected: data.isPooled === true,
          field: 'isPooled'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].buttons.no),
          selected: data.isPooled === false,
          field: 'isPooled'
        },
        handleChange: function handleChange() {
          return _this2._saveInGlobalState('isPooled', !data.isPooled);
        }
      }), data.isPooled ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.healthLifestyleSpendingMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.pooledAmountAvailable,
        onChange: function onChange(e) {
          return _this2._handleChange("pooledAmountAvailable", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("pooledAmountAvailable", e.target.value);
        },
        error: errors.pooledAmountAvailable,
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.allow1YearRollover),
        fullWidth: true,
        value: localizationMaps.fromEnglish('yesOrNo', data.allowPooledAmountRollover),
        variant: "outlined",
        error: errors.allowPooledAmountRollover,
        onChange: function onChange(e) {
          return _this2._handleChange("allowPooledAmountRollover", localizationMaps.toEnglish('yesOrNo', e.target.value));
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("allowPooledAmountRollover", localizationMaps.toEnglish('yesOrNo', e.target.value));
        },
        select: true,
        selectOptions: _services.selectFieldOptions.yesOrNo()
      })), data.allowPooledAmountRollover === 'Yes' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.setRolloverMaximum),
        fullWidth: true,
        value: localizationMaps.fromEnglish('yesOrNo', data.setMaxPooledRollover),
        variant: "outlined",
        error: errors.setMaxPooledRollover,
        onChange: function onChange(e) {
          return _this2._handleChange("setMaxPooledRollover", localizationMaps.toEnglish('yesOrNo', e.target.value));
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("setMaxPooledRollover", localizationMaps.toEnglish('yesOrNo', e.target.value));
        },
        select: true,
        selectOptions: _services.selectFieldOptions.yesOrNo()
      })), data.setMaxPooledRollover === 'Yes' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.healthSpendingRolloverMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.maxHsaRollover,
        onChange: function onChange(e) {
          return _this2._handleChange("maxHsaRollover", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("maxHsaRollover", e.target.value);
        },
        error: errors.maxHsaRollover,
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.lifestyleSpendingRolloverMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.maxLsaRollover,
        onChange: function onChange(e) {
          return _this2._handleChange("maxLsaRollover", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("maxLsaRollover", e.target.value);
        },
        error: errors.maxLsaRollover,
        variant: "outlined"
      })))))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.selectItemsToInclude)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.spendingAccounts.healthSpendingAccount),
        isSelected: data.includeHsa,
        onClick: function onClick() {
          return _this2._saveInGlobalState("includeHsa", !data.includeHsa);
        }
      }))), data.includeHsa && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.spendingAccounts.healthSpendingMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.hsaAmount,
        onChange: function onChange(e) {
          return _this2._handleChange("hsaAmount", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("hsaAmount", e.target.value);
        },
        error: errors.hsaAmount,
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.allow1YearRollover),
        fullWidth: true,
        value: localizationMaps.fromEnglish('yesOrNo', data.allowHsaRollover),
        variant: "outlined",
        error: errors.allowHsaRollover,
        onChange: function onChange(e) {
          return _this2._handleChange("allowHsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value));
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("allowHsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value));
        },
        select: true,
        selectOptions: _services.selectFieldOptions.yesOrNo()
      })), data.allowHsaRollover === 'Yes' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.setRolloverMaximum),
        fullWidth: true,
        value: localizationMaps.fromEnglish('yesOrNo', data.setMaxHsaRollover),
        variant: "outlined",
        error: errors.setMaxHsaRollover,
        onChange: function onChange(e) {
          return _this2._handleChange("setMaxHsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value));
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("setMaxHsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value));
        },
        select: true,
        selectOptions: _services.selectFieldOptions.yesOrNo()
      })), data.setMaxHsaRollover === 'Yes' && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.healthSpendingRolloverMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.maxHsaRollover,
        onChange: function onChange(e) {
          return _this2._handleChange("maxHsaRollover", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("maxHsaRollover", e.target.value);
        },
        error: errors.maxHsaRollover,
        variant: "outlined"
      })))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.spendingAccounts.lifestyleSpendingAccount),
        isSelected: data.includeLsa,
        onClick: function onClick() {
          return _this2._saveInGlobalState("includeLsa", !data.includeLsa);
        }
      }))), data.includeLsa && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.spendingAccounts.lifestyleSpendingMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.lsaAmount,
        onChange: function onChange(e) {
          return _this2._handleChange("lsaAmount", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("lsaAmount", e.target.value);
        },
        error: errors.lsaAmount,
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.allow1YearRollover),
        fullWidth: true,
        value: localizationMaps.fromEnglish('yesOrNo', data.allowLsaRollover),
        variant: "outlined",
        error: errors.allowLsaRollover,
        onChange: function onChange(e) {
          return _this2._handleChange("allowLsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value));
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("allowLsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value));
        },
        select: true,
        selectOptions: _services.selectFieldOptions.yesOrNo()
      })), data.allowLsaRollover === 'Yes' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.setRolloverMaximum),
        fullWidth: true,
        value: localizationMaps.fromEnglish('yesOrNo', data.setMaxLsaRollover),
        variant: "outlined",
        error: errors.setMaxLsaRollover,
        onChange: function onChange(e) {
          return _this2._handleChange("setMaxLsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value));
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("setMaxLsaRollover", localizationMaps.toEnglish('yesOrNo', e.target.value));
        },
        select: true,
        selectOptions: _services.selectFieldOptions.yesOrNo()
      })), data.setMaxLsaRollover === 'Yes' && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.lifestyleSpendingRolloverMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.maxLsaRollover,
        onChange: function onChange(e) {
          return _this2._handleChange("maxLsaRollover", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("maxLsaRollover", e.target.value);
        },
        error: errors.maxLsaRollover,
        variant: "outlined"
      }))))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.enableProrating)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].buttons.yes),
          selected: data.isProrated === true,
          field: 'isPooled'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].buttons.no),
          selected: data.isProrated === false,
          field: 'isPooled'
        },
        handleChange: function handleChange() {
          return _this2._saveInGlobalState('isProrated', !data.isProrated);
        }
      }), data.isProrated && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.typeOfProration)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.planDesign.day),
          selected: data.proratedBy === 'day',
          field: 'day'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].labels.planDesign.month),
          selected: data.proratedBy === 'month',
          field: 'month'
        },
        third: {
          title: _i18n["default"].t(_tokens["default"].labels.planDesign.quarter),
          selected: data.proratedBy === 'quarter',
          field: 'quarter'
        },
        handleChange: function handleChange(field, value) {
          return _this2._saveInGlobalState('proratedBy', field);
        },
        whitelabel: this.props.whitelabel
      })), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.enableQuarterlyAllowance)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        tiny: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.noteQuarterlyAllowance)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].buttons.yes),
          selected: data.isQuarterlyAllowance === true,
          field: 'isQuarterlyAllowance'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].buttons.no),
          selected: data.isQuarterlyAllowance === false,
          field: 'isQuarterlyAllowance'
        },
        handleChange: function handleChange() {
          return _this2._saveInGlobalState('isQuarterlyAllowance', !data.isQuarterlyAllowance);
        },
        disabled: data.isProrated === true
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        margin: "20px 0 10px 0"
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.planEligibilityTermination)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.completeFollowing)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.eligibilityPeriodMonths),
        fullWidth: true,
        value: data.eligibilityPeriod,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("eligibilityPeriod", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("eligibilityPeriod", e.target.value);
        },
        error: errors.eligibilityPeriod
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.minimumHoursPerWeek),
        fullWidth: true,
        value: data.minHoursPerWeek,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("minHoursPerWeek", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("minHoursPerWeek", e.target.value);
        },
        error: errors.minHoursPerWeek
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.terminationAge),
        fullWidth: true,
        value: data.terminationAge,
        onChange: function onChange(e) {
          return _this2._handleChange("terminationAge", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("terminationAge", e.target.value);
        },
        error: errors.terminationAge,
        variant: "outlined"
      }))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        bold: true
      }, "Notes:"), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        fullWidth: true,
        value: data.notes || '',
        variant: "outlined",
        error: errors.notes,
        onChange: function onChange(e) {
          return _this2._handleChange("notes", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("notes", e.target.value);
        },
        multiline: true,
        rows: 5,
        placeholder: _i18n["default"].t(_tokens["default"].labels.planDesign.additionalRequestsInformation)
      })));
    }
  }]);
}(_react.Component);
var _default = exports["default"] = SpendingAccounts;